export default "__VITE_ASSET__8bf8b0db__"